import React,{useState} from 'react';
import {BrowserRouter as Router, Switch,Route,Link} from 'react-router-dom'
import './App.css';
import CustomerDashboard from "./CustomerPanel/CustomerDashboard"
import PaymentAuth from "./CustomerPanel/PaymentAuth"
import RequestOrder from "./CustomerPanel/RequestOrder/RequestOrder"
import UserProfile from './CustomerPanel/UserProfile/UserProfile';
import ViewLedger from "./CustomerPanel/Ledger/ViewLedger"
// import Calculator from "./CustomerPanel/Calculator"
import Calc from "./CustomerPanel/Calc"
import OrderList from "./CustomerPanel/OrderList/OrderList"
// import LoginES from './CustomerPanel/LoginES';
import Login_ES from './CustomerPanel/Login_ES';
import Contact from "./CustomerPanel/Contact"
import Login from "./CustomerPanel/Login"
import SignUp_ES from "./CustomerPanel/SignUp_ES"
import SignUp from "./CustomerPanel/SignUp"
import HomePage from './CustomerPanel/HomePage/HomePage.js'
// import ReadyToShop from "./CustomerPanel/ReadyToShopES"
import SignUpDisplay from './CustomerPanel/SignUpDisplay'
import ReadyToShop from "./CustomerPanel/ReadyToShopNewUser"
import {UserContext} from "./CustomerPanel/Context/UserContext"
import { SignalCellularNullSharp } from '@material-ui/icons';
import ReferralTo from "./CustomerPanel/ReferralTo";
import ReferralList from "./CustomerPanel/ReferralList/OrderList";
import ChangePwd from "./CustomerPanel/ChangePwd";
import CouponList from "./CustomerPanel/CouponList/OrderList"
import ChangeMethod from "./CustomerPanel/ChangeMethod";
import ShippingAdd from "./CustomerPanel/ShippingAdd";


function App() {
  const [EzzId,setEzzId]=useState(null);
 
  return (
    <Router>
    <div>
    <UserContext.Provider value={EzzId,setEzzId}>
    <Switch>
    <Route exact path="/" component={Login}/> 
    {/* <Route exact path="/login_es" component={LoginES}/>  */}
    <Route exact path="/login_es" component={Login_ES}/> 

    {/* <Route exact path="/homepage" component={HomePage}/> */}
    <Route exact path="/signup" component={SignUp}/>
    <Route exact path="/signup_es" component={SignUp_ES}/>
    <Route exact path="/readytoshop" component={ReadyToShop}/>
    {/* <Route exact path="/signupdisplay" component={SignUpDisplay}/> */}
    <Route exact path="/customerdashboard" render={(props)=> <CustomerDashboard {...props}/>} />
    <Route exact path="/paymentauth" component={PaymentAuth}/>
    <Route exact path="/requestorder" component={RequestOrder}/>
    <Route exact path="/userprofile" component={UserProfile}/>
    <Route exact path="/viewledger" component={ViewLedger}/>
    <Route exact path="/orderlist" component={OrderList}/>
	<Route exact path="/referrallist" component={ReferralList}/>
    {/* <Route exact path="/calculator" component={Calculator}/> */}
    <Route exact path="/calculator" component={Calc}/>
	<Route exact path="/referralto" component={ReferralTo}/>
	<Route exact path="/changepwd" component={ChangePwd}/>
	<Route exact path="/couponlist" component={CouponList}/>
	<Route exact path="/contact" component={Contact}/>
  <Route exact path="/changemethod" component={ChangeMethod}/>
  <Route exact path="/shippingadd" component={ShippingAdd}/>
    {/* TEMP PAGE FOR ADDRESS MODAL */}
    {/* <Route exact path="/address" component={ReadyToShop}/>         */}

    </Switch>
    </UserContext.Provider>
   
    </div>
    </Router>
  );
}


export default App;
